'use client';
import Toman from '@/app/_components/ui/icons/Toman.svg';
import ArrowTop from '@/app/_components/ui/icons/ArrowTop.svg';
import Link from 'next/link';
import { useState } from 'react';
import AverageRating from '../share/AverageRating';
import Image from 'next/image';

export default function SpCompareProduct({
  thumb,
  title,
  attr,
  indices,
  slug,
  sale,
  compares,
}) {
  const [closeSection, setCloseSection] = useState(false);

  return (
    <>
      <div
        className="spCompareProduct  mt-3 md:mt-8 md:p-8 p-0 bg-white"
        id="spCompareProduct"
      >
        <div className="flex md:pb-6 md:pt-0 md:px-0 p-4 justify-between border-b border-light-gray-300 md:border-none">
          <div className="spNavTitle text-sm md:text-base font-bold">
            مقایسه کالاهای مشابه
          </div>
          <div
            className="md:hidden"
            onClick={() => setCloseSection((prev) => !prev)}
          >
            <ArrowTop className={`${closeSection && 'rotate-180'}`} />
          </div>
        </div>

        <div
          className={`${
            closeSection
              ? 'mt-0 p-0 h-0 overflow-hidden '
              : 'p-2 md:p-0 mt-4 md:mt-0 '
          }`}
        >
          <div className="compareTable border border-border-color overflow-auto   text-sm ">
            <div className="compareRow flex flex-nowrap flex-row ">
              <div className="compareCol flex flex-col  flex-[1_0_33.33333%] md:flex-[0_1_10%] items-center justify-center p-3.5"></div>
              <div className="compareCol flex flex-col flex-[1_0_33.33333%] md:flex-[0_1_26.6666%] items-center justify-center p-3.5">
                <Image
                  src={thumb?.full_path}
                  width={150}
                  height={137}
                  alt={thumb.alt}
                />
                <div className=" text-gray-600 mt-14 text-right mb-4">
                  {title}
                </div>
              </div>
              {compares?.compare_products.length > 0 &&
                compares?.compare_products.map((cmProduct, index) => (
                  <Link
                    href={`/product/${cmProduct.slug}`}
                    key={index}
                    target="_blank"
                    className="compareCol flex-[1_0_33.33333%] md:flex-[0_1_26.6666%] p-3.5"
                  >
                    <div className=" flex flex-col   items-center justify-center ">
                      <Image
                        src={cmProduct.media.thumb.full_path}
                        width={150}
                        height={137}
                        alt={cmProduct.media.thumb.alt}
                      />
                      <div className=" text-gray-600 mt-14 text-right mb-4">
                        {cmProduct.title}
                      </div>
                    </div>
                  </Link>
                ))}
            </div>
            <div className="compareRow flex flex-nowrap flex-row bg-gray-bg border-b-2 border-white">
              <div className="compareCol flex flex-col  text-sm   bg-gray-bg  flex-[1_0_33.33333%] md:flex-[0_1_10%] items-center justify-center p-3.5">
                امتیاز
              </div>
              <div className="compareCol flex flex-col   bg-gray-bg flex-[1_0_33.33333%] md:flex-[0_1_26.6666%]  items-center justify-center p-3.5 ">
                <div className="flex ">
                  {indices.total != 0 ? (
                    <>
                      <AverageRating score={indices.score} size="small" />
                      <div className="flex hidden sm:block  pr-3.5">
                        <span className="text-light-gray-900">
                          {indices.score}
                        </span>
                        <span className="text-gray-200 pr-2">
                          ({indices.total})
                        </span>
                      </div>
                    </>
                  ) : (
                    <>بدون امتیاز</>
                  )}
                </div>
              </div>
              {compares.compare_products.map((cmProduct, index) => (
                <div
                  key={index}
                  className="compareCol flex flex-col   bg-gray-bg flex-[1_0_33.33333%] md:flex-[0_1_26.6666%]  items-center justify-center p-3.5"
                >
                  {cmProduct.total && cmProduct.total != 0 ? (
                    <div className="flex ">
                      <AverageRating score={cmProduct.score} size="small" />
                      <div className="flex hidden sm:block  pr-3.5">
                        <span className="text-light-gray-900">
                          {cmProduct.score}
                        </span>
                        <span className="text-gray-200 pr-2">
                          ({cmProduct.total})
                        </span>
                      </div>
                    </div>
                  ) : (
                    <>بدون امتیاز</>
                  )}
                </div>
              ))}
            </div>
            <div className="compareRow flex flex-nowrap flex-row bg-gray-bg border-b-2 border-white">
              <div className="compareCol flex flex-col bg-gray-bg  flex-[1_0_33.33333%] md:flex-[0_1_10%]  items-center justify-center p-3.5">
                قیمت
              </div>
              <div className="compareCol flex flex-col  bg-gray-bg  flex-[1_0_33.33333%] md:flex-[0_1_26.6666%]  items-center justify-center p-3.5">
                <div className="flex md:text-sm text-sm  text-gray-500  flex items-center">
                  <span className="pl-1">{sale?.toLocaleString('fa-IR')}</span>
                  <Toman fill="#5b6269" />
                </div>
              </div>
              {compares.compare_products.map((cmProduct, index) => (
                <div
                  key={index}
                  className="compareCol flex flex-col flex-[1_0_33.33333%] md:flex-[0_1_26.6666%]  items-center justify-center p-3.5"
                >
                  <div className="flex  md:text-sm text-sm text-gray-500 flex items-center">
                    {cmProduct.prices.length > 0 ? (
                      <>
                        <span className="pl-1">
                          {cmProduct.prices[0].sale?.toLocaleString('fa-IR')}
                        </span>
                        <Toman fill="#5b6269" />
                      </>
                    ) : (
                      <span className="text-sm">بدون قیمت</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
            {compares.compare_category_attributes.length > 0 &&
              compares.compare_category_attributes.map((selectedAttr) => (
                <div className="compareRow  flex flex-nowrap flex-row bg-gray-bg border-b-2 border-white">
                  <div className="compareCol flex flex-col bg-gray-bg text-center flex-[1_0_33.33333%] md:flex-[0_1_10%]  items-center justify-center p-3.5">
                    {selectedAttr.name}
                  </div>
                  <div className="compareCol flex flex-col  bg-gray-bg  flex-[1_0_33.33333%] md:flex-[0_1_26.6666%]  items-center justify-center p-3.5">
                    <div className="flex  text-sm  text-gray-500  flex items-center">
                      <span className="pl-1">
                        {attr.find((att) => att.name === selectedAttr.name)
                          ?.values || '-'}
                      </span>
                    </div>
                  </div>
                  {compares.compare_products.map((cmProduct, index) => (
                    <div
                      key={index}
                      className="compareCol flex flex-col flex-[1_0_33.33333%] md:flex-[0_1_26.6666%]  items-center justify-center p-3.5"
                    >
                      <div className="flex   text-sm text-gray-500 flex items-center">
                        {(cmProduct.compare_attributes &&
                          cmProduct.compare_attributes.find(
                            (att) => att.name === selectedAttr.name
                          )?.value) ||
                          '-'}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}
